import Cashflow from '../../../models/cashflows/cashflow';
import CashflowsPage from '../../../models/cashflows/cashflows-page';
import AccountingApiClient from '../base-client';

class CashflowsApi extends AccountingApiClient<Cashflow, CashflowsPage> {
  public constructor() {
    super('/cashflows');
  }

  public getPage = async ({
    page = 1,
    perPage = 10,
    filter,
  }: {
    page?: number;
    perPage?: number;
    filter?: { startMonth: string | null; endMonth: string | null };
  } = {}): Promise<CashflowsPage> => {
    let url = `${this.baseUrl}?page=${page}&per_page=${perPage}`;

    if (filter && (filter.startMonth || filter.endMonth)) {
      const expressions = [];
      // Use 'ge' for >= and 'le' for <= in OData style filter
      if (filter.startMonth)
        expressions.push(`month gte '${filter.startMonth}'`);
      if (filter.endMonth) expressions.push(`month lte '${filter.endMonth}'`);
      url += `&filter=${expressions.join(' and ')}`;
    }

    return super.httpList(url);
  };
}

const cashflowsApi = new CashflowsApi();

export default cashflowsApi;
